import React, { useContext } from "react";
import { AutoDialContext } from "../../context";

const MakeSomeHeightComponent = () => {
  const { dialTimer } = useContext(AutoDialContext);
  return <div style={{ height: !!dialTimer ? "50px" : "0px" }} />;
};

export { MakeSomeHeightComponent };
